import { apiGet, apiPost, apiPut, apiDelete, apiPatch, apiPostWithMultiPart } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  // Create new CPT codes
  createCptCodes: (payload) => apiPost(domainUrl(`/v1/cpt-codes`), payload),

  previewImport: (payload) => apiPostWithMultiPart(domainUrl(`/v1/cpt-codes/preview-import`), payload),
  
  // Get all CPT codes with pagination
  getCptCodesList: (size=5000, current=1, searchInput="") => apiGet(domainUrl(`/v1/cpt-codes?limit=${size}&page=${current}&code=${searchInput}`)),

  
  // Get a specific CPT code by ID
  getCodeById: (id) => apiGet(domainUrl(`/v1/cpt-codes/${id}`)),
  
  // Update an existing CPT code
  updateCptCodes: (id, payload) => apiPut(domainUrl(`/v1/cpt-codes/${id}`), payload),
  
  // Delete CPT codes
  deleteCode: (payload) => apiPost(domainUrl(`/v1/cpt-codes/delete`), payload),
};

